import React, {createContext, useContext, useState, Dispatch, SetStateAction, ReactNode} from 'react';
import axios from 'axios';
import Header from "../components/Header";
import Footer from "../components/Footer";
import {useTranslation} from 'react-i18next';
import config from '../config/config.json';
import { Helmet } from 'react-helmet';
import RuntimeValuesProvider, { RuntimeValuesContext } from '../context/RuntimeValuesContext';

function Shipment() {
    const [t, i18n] = useTranslation("global");
    const {runtimeValues, setRuntimeValues} = useContext(RuntimeValuesContext);
    const [title, setTitle] = useState<string>(t("pageTitle.us") + t("seo.compl") + runtimeValues.country + " - wicaglobalgear.com");
    /*const apiKey = config.dhl.api_id + ":" + config.dhl.secret_id;*/

    interface Values {
        accountNumber: string
        originCountryCode: string
        originPostalCode: string
        originCityName: string
        destinationCountryCode: string
        destinationCityName: string
        weight: string
        length: string
        width: string
        height: string
        plannedShippingDate: string
        isCustomsDeclarable: string
        unitOfMeasurement: string
        xversion: string
    }

    const [values, setValues] = useState<Values>({
        accountNumber: "861478873",
        originCountryCode: "US",
        originPostalCode: "32827",
        originCityName: "Orlando",
        destinationCountryCode: "CO",
        destinationCityName: "Medellin",
        weight: "5",
        length: "15",
        width: "10",
        height: "2",
        plannedShippingDate: "2024-12-17",
        isCustomsDeclarable: "false",
        unitOfMeasurement: "metric",
        xversion: "2.12.0"
    });

    const handleChangeValues = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setValues({...values, [name]: value });
    };    

    const handleShipment = async () => {
        try{
            const axiosInstance = axios.create({
                /*baseURL: config.dhl.url + '/rates',*/
                baseURL: config.backend.url + '/api/dhl/shipmentrate',
                //auth: {
                //    'username':'apJ4zP4rK4rA7q',
                //    'password':'B$3bC@5wE#3yL^7e'
                    /*'password': 'Basic ' + btoa(apiKey),*/
                //},
                params:{
                    accountNumber: values.accountNumber,
                    originCountryCode: values.originCountryCode,
                    originPostalCode: values.originPostalCode,
                    originCityName: values.originCityName,
                    destinationCountryCode: values.destinationCountryCode,
                    destinationCityName: values.destinationCityName,
                    weight: values.weight,
                    length: values.length,
                    width: values.width,
                    height: values.height,
                    plannedShippingDate: values.plannedShippingDate,
                    isCustomsDeclarable: values.isCustomsDeclarable,
                    unitOfMeasurement: values.unitOfMeasurement,
                    xversion: values.xversion
                }                
            });

            /*const response = await axiosInstance.get(config.dhl.url + '/rates'); */
            const response = await axiosInstance.post(config.backend.url + '/api/dhl/shipmentrate');
            console.log(response.data);
              //if(response.status === 201){
              //  console.log(response.data);
              //  navigate(`/orderDetail?orderId=${response.data.id}`);
              //}
        //Redirecciono para ver el detalle de la orden
        }catch(error){
            console.error(error);
        }        
    };
return ( <>
        <Helmet>
            <title>{title}</title> 
        </Helmet>
        <div className="app-container">          
        <Header />
        <div className="app-content">
        <section className="sectionPageContent">
            <h1>
                {t("pageTitle.shipment")} 
            </h1>    

            <div className="cartContainer">
                <div className="cartItemContainerLeft">
                    <div className="form">
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="originCountryCode" value={values.originCountryCode} onChange={handleChangeValues} />
                                <div className="underline"></div>
                                <label htmlFor="">Origin Country</label>
                            </div>
                        </div>      
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="originPostalCode" value={values.originPostalCode} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Origin Postal Code</label>
                            </div>
                        </div>         
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="originCityName" value={values.originCityName} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Origin City</label>
                            </div>
                        </div>          
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="destinationCountryCode" value={values.destinationCountryCode} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Destination Country</label>
                            </div>
                        </div>     
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="destinationCityName" value={values.destinationCityName} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Destination City</label>
                            </div>
                        </div>      
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="weight" value={values.weight} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Weight</label>
                            </div>
                        </div>    
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="length" value={values.length} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Lenght</label>
                            </div>
                        </div>      
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="width" value={values.width} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Width</label>
                            </div>
                        </div>  
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="height" value={values.height} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Height</label>
                            </div>
                        </div>                                                       
                        <div className="form-row">
                            <div className="input-data">
                                <input type="text" name="plannedShippingDate" value={values.plannedShippingDate} onChange={handleChangeValues}  />
                                <div className="underline"></div>
                                <label htmlFor="">Date</label>
                            </div>
                        </div>                                                                                                                                                             
                    </div>
                </div>
            </div>
            <div className="product-actions">                
                <button className="plpButtonFocus" onClick={() => handleShipment()}>{t("general.completeOrder")}</button>    
            </div>            
        </section>
        </div>        
        <Footer />
        </div>         
        </>    );
}

export default Shipment;      